module.exports = __webpack_public_path__ + "img/avatar1.671a5283.png";